import { RegisteredComponent } from "@builder.io/sdk-react";

export const itsmPdfButtonsBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "ITSMPdfButtons",
    noWrap: true,
    shouldReceiveBuilderProps: {
      builderContext: true,
    },
    inputs: [
      {
        name: "downloadButtonText",
        friendlyName: "Download Button Text",
        type: "string",
        defaultValue: "Download Your Maturity Model",
        localized: true,
        required: true,
      },
      {
        name: "downloadButtonDld",
        friendlyName: "Download Button - Data Link Details",
        type: "string",
        defaultValue: "Download PDF",
        localized: false,
      },
      {
        name: "downloadButtonDlt",
        friendlyName: "Download Button - Data Link Type",
        type: "string",
        defaultValue: "Button",
        localized: false,
      },
      {
        name: "printButtonText",
        friendlyName: "Print Button Text",
        type: "string",
        defaultValue: "Print",
        localized: true,
        required: true,
      },
      {
        name: "printButtonDld",
        friendlyName: "Print Button - Data Link Details",
        type: "string",
        defaultValue: "Print PDF",
        localized: false,
      },
      {
        name: "printButtonDlt",
        friendlyName: "Print Button - Data Link Type",
        type: "string",
        defaultValue: "Button",
        localized: false,
      },
      {
        name: "startNewModelButtonText",
        friendlyName: "Start New Model Button Text",
        type: "string",
        defaultValue: "Start New Model",
        localized: true,
        required: true,
      },
      {
        name: "startNewModelButtonDld",
        friendlyName: "Start New Model Button - Data Link Details",
        type: "string",
        defaultValue: "Start New Model",
        localized: false,
      },
      {
        name: "startNewModelButtonDlt",
        friendlyName: "Start New Model Button - Data Link Type",
        type: "string",
        defaultValue: "Button",
        localized: false,
      },
      {
        name: "modalHeadline",
        friendlyName: "Clear Modal - Headline",
        type: "string",
        defaultValue: "Clear selections and start new model",
        localized: true,
        required: true,
      },
      {
        name: "modalDescription",
        friendlyName: "Clear Modal - Description",
        type: "longText",
        defaultValue: "Starting a new model will erase all current selections.",
        localized: true,
      },
      {
        name: "modalBackButtonText",
        friendlyName: "Clear Modal - Back Button Text",
        type: "string",
        defaultValue: "Back to My Model",
        localized: true,
        required: true,
      },
      {
        name: "modalStartNewButtonText",
        friendlyName: "Clear Modal - Start New Button Text",
        type: "string",
        defaultValue: "Start New Model",
        localized: true,
        required: true,
      },
      {
        name: "pdfTitle",
        friendlyName: "PDF Title",
        type: "string",
        defaultValue: "ITSM Maturity Model",
        localized: true,
      },
    ],
  };
